/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetFailuresQueryResponse, IngestionStatusControllerGetFailuresQueryParams, IngestionStatusControllerGetFailures403 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetFailures";

function getIngestionStatusControllerGetFailuresUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/ingestion-status/failures` as const }  
  return res
}

/**
 * @description Returns detailed information about failures across files, documents, and jobs, including error patterns and individual failure records. Requires System Administrator role.
 * @summary Get detailed failure analysis
 * {@link /api/v1/documents/ingestion-status/failures}
 */
export async function ingestionStatusControllerGetFailures(params?: IngestionStatusControllerGetFailuresQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IngestionStatusControllerGetFailuresQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetFailures403>, unknown>({ method : "GET", url : getIngestionStatusControllerGetFailuresUrl().url.toString(), params, ... requestConfig })  
  return res.data
}